// TEMPORARY: Braze push sync — remove when legacy facility app is sunset
import { brazePushSyncChangeUser } from "@src/appV2/NativeAdapters/brazePushSync.adapter";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import { Platform } from "@src/mobile/utils/platform";
import { useEffect } from "react";

interface UseBrazePushSyncParams {
  workplaceUserId: string;
  isAdmin: boolean;
}

/**
 * Identifies the current workplace user in the Braze native SDK so that
 * push tokens registered in the native layer are associated with the
 * correct user profile in Braze.
 *
 * This is a temporary bridge for backwards compatibility while the legacy
 * facility app is still active and chat notifications are delivered via Braze.
 * Remove this hook when the legacy app is sunset and chat notifications
 * are migrated to Knock.
 */
export function useBrazePushSync(params: UseBrazePushSyncParams): void {
  const { workplaceUserId, isAdmin } = params;

  useEffect(() => {
    if (!Platform.isMobile || !workplaceUserId || isAdmin) {
      return;
    }

    void brazePushSyncChangeUser(workplaceUserId).catch((error: unknown) => {
      logError(APP_V2_APP_EVENTS.BRAZE_PUSH_SYNC_FAILURE, { error });
    });
  }, [workplaceUserId, isAdmin]);
}
